export const SET_LOADING_DATA = '@routedClientsReport/SET_LOADING_DATA';
export const SET_LOADING_SELECTS = '@routedClientsReport/SET_LOADING_SELECTS';

export const GET_LIST_ALL_REQUEST = '@routedClientsReport/GET_LIST_ALL_REQUEST';
export const GET_LIST_ALL_SUCCESS = '@routedClientsReport/GET_LIST_ALL_SUCCESS';

export const GET_LIST_SELECTS_REQUEST = '@routedClientsReport/GET_LIST_SELECTS_REQUEST';
export const GET_LIST_SELECTS_SUCCESS = '@routedClientsReport/GET_LIST_SELECTS_SUCCESS';

export const SHARE_CSV = '@routedClientsReport/SHARE_CSV';

export const SET_PAGE = '@routedClientsReport/SET_PAGE';
export const SET_ROWS_COUNT = '@routedClientsReport/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@routedClientsReport/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@routedClientsReport/SET_ORDER';
export const SET_ORDERBY = '@routedClientsReport/SET_ORDERBY';
